import { isUndefined } from 'lodash-es'
import { MMKV } from 'react-native-mmkv'

const kv = new MMKV({
  id: 'app-storage',
})

const storage = {
  get: <T>(key: string): T | null => {
    const jsonValue = kv.getString(key)
    if (!jsonValue) return null
    return JSON.parse(jsonValue)
  },
  set: (key: string, value: any) => {
    if (isUndefined(value)) {
      storage.remove(key)
      return
    }
    kv.set(key, JSON.stringify(value))
  },
  remove: (key: string) => {
    kv.delete(key)
  },
  clear: () => {
    kv.clearAll()
  },
}

export default storage
